import PropTypes from 'prop-types';

export default class UISelectorItem {
    static propTypes = {
        id : PropTypes.string.isRequired,
        name :  PropTypes.string.isRequired
    };

    constructor(id, name) {
        this.id = id;
        this.name = name;
    }

}